"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Overflow = _interopRequireDefault(require("./Overflow"));

var _default = _Overflow.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-overflow/lib/index.js
// module id = 333
// module chunks = 0